import React from 'react';
import { Card, Badge, Alert } from 'react-bootstrap';
import { Shield, Eye, Share2, Settings, Mail, Phone } from 'react-feather';

export default function Privacy(){
  return (
    <Card className="shadow-lg border-0 rounded-3">
      <Card.Header className="bg-white border-0 pt-4">
        <div className="d-flex align-items-center gap-3 mb-2">
          <div className="bg-primary bg-opacity-10 p-2 rounded">
            <Shield size={24} className="text-primary" />
          </div>
          <div>
            <h2 className="fw-bold text-dark mb-1">Privacy Policy</h2>
            <Badge bg="light" text="dark" className="fw-normal">Overview</Badge>
          </div>
        </div>
      </Card.Header>
      
      <Card.Body className="pt-3">
        <Alert variant="info" className="border-0 bg-light-info mb-4">
          <small className="fw-medium">
            We collect limited personal data to operate the service, prevent fraud, and comply with law. 
            We do not sell your data.
          </small>
        </Alert>

        <div className="privacy-content">
          <section className="mb-4">
            <div className="d-flex align-items-center gap-2 mb-3">
              <div className="bg-warning bg-opacity-10 p-2 rounded">
                <Eye size={18} className="text-warning" />
              </div>
              <h5 className="fw-bold text-dark mb-0">Data We Process</h5>
            </div>
            <ul className="list-unstyled mb-0">
              <li className="mb-2 d-flex align-items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span className="text-muted">Account data: name, phone, email, profile photo, bank details for payouts.</span>
              </li>
              <li className="mb-2 d-flex align-items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span className="text-muted">Operational data: route assignments, scanned delivery proofs, timestamps, device info.</span>
              </li>
              <li className="d-flex align-items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span className="text-muted">Location (during active shift) to optimize routes and confirm delivery attempts.</span>
              </li>
            </ul>
          </section>

          <section className="mb-4">
            <div className="d-flex align-items-center gap-2 mb-3">
              <div className="bg-success bg-opacity-10 p-2 rounded">
                <Settings size={18} className="text-success" />
              </div>
              <h5 className="fw-bold text-dark mb-0">How We Use Data</h5>
            </div>
            <ul className="list-unstyled mb-0">
              <li className="mb-2 d-flex align-items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span className="text-muted">Operate and improve logistics.</span>
              </li>
              <li className="mb-2 d-flex align-items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span className="text-muted">Provide support and investigate incidents.</span>
              </li>
              <li className="d-flex align-items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span className="text-muted">Comply with financial, tax, and safety regulations.</span>
              </li>
            </ul>
          </section>

          <section className="mb-4">
            <div className="d-flex align-items-center gap-2 mb-3">
              <div className="bg-info bg-opacity-10 p-2 rounded">
                <Share2 size={18} className="text-info" />
              </div>
              <h5 className="fw-bold text-dark mb-0">Sharing</h5>
            </div>
            <p className="text-muted mb-0 small">
              Shared only with service providers (payments, hosting, ID verification) under contracts,
              or when required by law. Aggregated analytics may be used internally.
            </p>
          </section>

          <section className="mb-4">
            <div className="d-flex align-items-center gap-2 mb-3">
              <div className="bg-purple bg-opacity-10 p-2 rounded">
                <Settings size={18} className="text-purple" />
              </div>
              <h5 className="fw-bold text-dark mb-0">Your Choices</h5>
            </div>
            <ul className="list-unstyled mb-0">
              <li className="mb-2 d-flex align-items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span className="text-muted">Access/Update your data via profile settings.</span>
              </li>
              <li className="mb-2 d-flex align-items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span className="text-muted">Request deletion or portability by contacting support.</span>
              </li>
              <li className="d-flex align-items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span className="text-muted">Control location permissions on your device.</span>
              </li>
            </ul>
          </section>

          <section className="mt-4 pt-3 border-top">
            <h5 className="fw-bold text-dark mb-3">Contact</h5>
            <div className="d-flex flex-wrap gap-4">
              <div className="d-flex align-items-center gap-2 text-muted small">
                <Mail size={16} />
                <span>carevillagemilk@gmail.com</span>
              </div>
              <div className="d-flex align-items-center gap-2 text-muted small">
                <Phone size={16} />
                <span>8960060092</span>
              </div>
            </div>
          </section>
        </div>
      </Card.Body>
    </Card>
  );
}